import { Suspense } from 'react';
import type { GetServerSidePropsContext } from 'next';

import LoadingSpinnerCenter from '~/components/LoadingSpinnerCenter';
import { getSnowdonJwt } from '~/domains/auth/utils';
import { prefetchReactQueryData } from '~/libs/reactQuery';

import EventContainer from './components/EventContainer';
import { EventPageLayout } from './components/EventLayout';

const EventPage = () => {
  return (
    <Suspense
      fallback={
        <div className="h-[400px]">
          <LoadingSpinnerCenter />
        </div>
      }
    >
      <EventContainer />
    </Suspense>
  );
};

EventPage.Layout = EventPageLayout;

export default EventPage;

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const { req, query } = context;
  const { businessId } = req.cookies;
  const placement = `event_${query.placementName as string}`;
  const token = getSnowdonJwt(context) || null;

  if (!token || Number.isNaN(Number(businessId))) {
    return {
      props: {},
    };
  }

  const fetchOptions = {
    headers: {
      'X-Client-Auth-Token': token,
    },
  };

  const { dehydratedState } = await prefetchReactQueryData({
    queries: [
      [
        '/api/market-place/v1/placements/events',
        {
          businessId,
          placement,
        },
      ],
    ],
    fetchOptions,
  });

  return {
    props: {
      dehydratedState,
    },
  };
}
